import React from "react"
import PropTypes from "prop-types"
import GoogleMapReact from 'google-map-react';
import BtnPrimary from '../form_sections/BtnPrimary'
import googleMapStyle from '../utils/googleMapStyle'

const Marker = () => <div className="markerCircle"></div>;

class LocationSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      center: {
        lat: parseFloat(this.props.lat),
        lng: parseFloat(this.props.lng)
      },
      zoom: 11,
      lat: parseFloat(this.props.lat),
      lng: parseFloat(this.props.lng),
      draggable: false,
      loaded: false
    }
  }

  componentDidMount() {
    this.setState({
      center: {
        lat: parseFloat(this.props.lat),
        lng: parseFloat(this.props.lng)
      },
      zoom: 11,
      lat: parseFloat(this.props.lat),
      lng: parseFloat(this.props.lng),
      draggable: false,
      loaded: true
    })
  }

  render() {
    return (
      <div style={{margin: 'auto'}}>
        {this.state.lat != '' &&
        <div style={{height: '30vh', maxWidth: '100vh', margin: 'auto'}}>
          <div style={{ height: '100%', width: '100%' }}>
            <GoogleMapReact
              options={{
                  styles: googleMapStyle
              }}
              bootstrapURLKeys={{ key: process.env.GOOGLE_MAPS_KEY }}
              defaultCenter={this.state.center}
              center={{lat: this.state.lat, lng: this.state.lng}}
              defaultZoom={this.state.zoom}
              draggable={true}
              onChildMouseDown={() => this.onChildMouseDown()}
              onChildMouseUp={() => this.onChildMouseUp()}
              onChildMouseMove={(key, childProps, mouse) => this.onChildMouseMove(key, childProps, mouse)}
            >
              <Marker
                key={'id'}
                item={'n'}
                lat={this.state.lat}
                lng={this.state.lng}
              />
            </GoogleMapReact>
          </div>
        </div>}
      </div>
    );
  }
}


export default LocationSection;
